import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type SavedView, type SavedViewBody, updateSavedView } from '../lib/saved-views-client.js';
import { savedViewsQueryKey } from './use-saved-views.js';

interface UpdateSavedViewVars {
  viewId: string;
  body: SavedViewBody;
}

interface UseUpdateSavedViewOptions {
  tenantReportId: string;
}

export function useUpdateSavedView({ tenantReportId }: UseUpdateSavedViewOptions) {
  const queryClient = useQueryClient();

  return useMutation<SavedView, Error, UpdateSavedViewVars>({
    mutationFn: ({ viewId, body }: UpdateSavedViewVars) => updateSavedView(viewId, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: savedViewsQueryKey(tenantReportId) });
    },
  });
}
